<template>
  <div id="batchItem__modal">
    <vs-popup id="batchTrackItem__modal" :title="board.modalTitle" :style="{ 'z-index': zIndex }" :active.sync="isActive">
      <vs-table
        id="batch_plant__list"
        :total="FilteredCount"
        :max-items="length"
        class="vs-con-loading__container"
        stripe
        :sst="true"
        maxHeight="500px"
        pagination
        search
        @change-page="handleChangePage"
        @search="updateSearchQuery"
        :data="dataList"
      >
        <template slot="header">
          <!-- TABLE ACTION ROW -->
          <div class="flex flex-wrap justify-between items-center">
            <!-- ITEMS PER PAGE -->
            <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
              <vs-dropdown vs-trigger-click class="cursor-pointer">
                <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                  <span class="mr-2">
                    {{ page * length - (length - (FilteredCount && 1)) }}
                    -
                    {{ FilteredCount - page * length > 0 ? page * length : FilteredCount }}
                    of {{ FilteredCount }} (filtered from {{ total }} total entries)
                  </span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="handleChangeLength(10)">
                    <span>10</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="handleChangeLength(20)">
                    <span>20</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="handleChangeLength(50)">
                    <span>50</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="handleChangeLength(100)">
                    <span>100</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </div>
        </template>

        <template slot="thead">
          <vs-th sort-key="batch.id">Sr#</vs-th>
          <vs-th v-for="(item, index) in board.modalDataColumns" :key="index">{{ item.columnName }}</vs-th>
          <vs-th v-if="board.modalDataActions">Actions</vs-th>
        </template>

        <template slot-scope="{ data }" ref="tableBody">
          <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
            <!-- serial no -->
            <vs-td>{{ page * length - (length - i - 1) }}</vs-td>

            <vs-td v-for="(item, index) in board.modalDataColumns" :key="index">
              {{ handleFunctionCallValue(item, tr, item.value) }}
            </vs-td>

            <vs-td v-if="board.modalDataActions">
              <vs-dropdown vs-trigger-click class="cursor-pointer">
                <div class="p-4 border border-solid d-theme-border-grey-light cursor-pointer flex items-center justify-between font-medium">
                  Actions
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <vs-dropdown-menu class="batch_data__actions">
                  <vs-dropdown-item v-for="(item, index) in board.modalDataActions" :key="index" @click="handleActionCallback(item, tr)"> {{ item.label }} </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-popup>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import { plantStages } from '@/utils/batch-options'
import { backgrondScrollHandler } from '@/utils/functions'

export default {
  name: 'BatchTrackItemModal',

  components: {},

  props: {
    board: {
      type: Object,
      default: null
    },

    batch: {
      type: Object,
      default: null
    },

    active: {
      type: Boolean,
      default: false
    },

    isArchievedList: {
      type: Boolean,
      default: false
    },

    dryingStat: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      loading: false,
      selectedItem: null,
      zIndex: 0,

      page: 1,
      length: 10,
      order: [],
      search: null,

      FilteredCount: 0,
      total: 0,

      filters: {
        batchId: null
      },

      dataList: [],

      // edit plant modal
      isEditPlantModalMounted: false,
      isEditPlantModalShow: false,

      // split package modal
      isSplitPackageModalMounted: false,
      isSplitPackageModalShow: false,

      // remove waste modal
      isRemoveWasteModalMounted: false,
      isRemoveWasteModalShow: false,

      // create harvest package
      isCreateHarvestPackageModalMounted: false,
      isCreateHarvestPackageModalShow: false,

      // create harvest lab test modal
      isCreateHarvestLabPackageModalMounted: false,
      isCreateHarvestLabPackageModalShow: false,

      //update Package Quantity
      isUpdatePackageQtyModalMounted: false,
      isUpdatePackageQtyModalShow: false
    }
  },

  mounted() {
    // handle backgrond scroll
    backgrondScrollHandler(true)

    if (this.batch.id) this.filters.batchId = this.batch.id

    this.zIndex = this.modal.modalZIndex + this.modal.modalOpens + 1
  },

  computed: {
    ...mapState(['modal']),

    isActive: {
      get() {
        return this.active
      },
      set(val) {
        // handle backgrond scroll
        backgrondScrollHandler(false)

        this.$emit('update:active', val)
      }
    },

    getDotRecord() {
      return (data, key) => {
        const a = key.split('.')
        for (let i = 0, n = a.length; i < n; ++i) {
          const k = a[i]
          if (data && k && k in data) {
            data = data[k]
          } else {
            return
          }
        }
        return data
      }
    },

    renderPlantStage() {
      return plantStage => {
        return (plantStages.find(x => x.value === plantStage) || {}).label
      }
    },

    fetchKeyValuefromData() {
      return (keyArr, data) => {
        return keyArr.map(x => {
          return x.includes('.') ? this.getDotRecord(data, x) : data[x]
        })
      }
    }
  },

  methods: {
    ...mapMutations(['SET_MODAL_ZINDEX']),

    handleFunctionCallValue(item, data, key) {
      if (item.func) {
        const funcParams = item.funcParams && item.funcParams.length ? this.fetchKeyValuefromData(item.funcParams, data) : key
        return this[item.func](...funcParams)
      } else {
        return item.value.includes('.') ? this.getDotRecord(data, key) : data[key]
      }
    },

    // get records
    getInitialRecords(page = this.page) {
      this.loading = true
      this.$store
        .dispatch('batch/getBatchModalData', {
          url: this.board.modalDataEndPoint,
          payload: {
            page,
            limit: this.length,
            search: this.search,
            order: this.order,
            id: this.batch.id,
            isArchievedList: this.isArchievedList,
            ...this.board.modalDataPayloads,
            // conditional statics
            ...(this.board.boardDataPayloads.drying ? (this.dryingStat ? { plantStage: ['drying'] } : { plantStage: ['dried'] }) : {})
          },
          excludes: this.board.modalDataExcludePayloads || []
        })
        .then(res => {
          this.FilteredCount = res.FilteredCount
          this.total = res.total
          this.dataList = res.data
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    // fetch updated batch records
    fetchUpdatedRecords() {
      this.dataList = []
      this.page = 1
      this.getInitialRecords()
    },

    // handle search record
    updateSearchQuery(val) {
      this.page = 1
      this.search = val
      this.getInitialRecords()
    },

    // change per page length
    handleChangeLength(length) {
      this.page = 1
      this.length = length
      this.getInitialRecords()
    },

    // change page
    handleChangePage(page) {
      this.page = page
      this.getInitialRecords()
    },

    // handle action callback
    handleActionCallback(item, data) {
      this[item.action](data)
    },

    // toggle edit plant
    toggleEditPlant(data) {
      this.selectedItem = data
      this.isEditPlantModalMounted = true
      this.isEditPlantModalShow = true
    },

    // delete batch plant - confirmation
    deleteRecord(data) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: 'Are you sure, you want to delete this record?',
        accept: () => this.deleteBatchPlant(data.id),
        acceptText: 'Delete'
      })
    },

    // delete batch plant
    deleteBatchPlant(id) {
      this.loading = true
      this.$store
        .dispatch('batch/deleteBatchPlant', id)
        .then(() => {
          this.loading = false

          this.$vs.notify({
            title: 'Success',
            text: 'Batch deleted successfully!',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })

          // fetch latest data
          this.fetchUpdatedRecords()
        })
        .catch(({ message }) => {
          this.loading = false

          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },

    // toggle split package modal
    toggleSplitPackageModal(data) {
      this.selectedItem = data
      this.isSplitPackageModalMounted = true
      this.isSplitPackageModalShow = true
    },

    // delete package -- confirm box
    deletePackageConfirmBox(i) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: 'Are you sure, you want to delete this record?',
        accept: () => {
          this.deletePackage(i)
        },
        acceptText: 'Delete'
      })
    },

    // delete package
    deletePackage(i) {
      this.loading = true
      this.$store
        .dispatch('package/deletePackage', i)
        .then(({ message }) => {
          this.loading = false
          this.$vs.notify({
            title: 'Success',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })

          // fetch latest data
          this.fetchUpdatedRecords()
        })
        .catch(({ message }) => {
          this.loading = false
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },

    // toggle remove waste modal
    toggleRemoveWasteModal() {
      this.isRemoveWasteModalMounted = true
      this.isRemoveWasteModalShow = true
    },

    // toggle create harvest modal
    toggleCreateHarvestModal() {
      this.isCreateHarvestPackageModalMounted = true
      this.isCreateHarvestPackageModalShow = true
    },

    // toggle create harvest lab modal
    toggleCreateHarvestLabModal() {
      this.isCreateHarvestLabPackageModalMounted = true
      this.isCreateHarvestLabPackageModalShow = true
    },

    // toggle update package qty modal
    togglePackageQtyUpdateModal(data) {
      this.selectedItem = data
      this.isUpdatePackageQtyModalMounted = true
      this.isUpdatePackageQtyModalShow = true
    },

    // edit package modal
    editPackageHandler(data) {
      this.isActive = false
      this.$router.push({ name: 'package-edit', params: { id: data.id } })
    }
  },

  watch: {
    loading() {
      if (this.loading) {
        this.$vs.loading({
          container: '#batchTrackItem__modal .vs-popup .vs-popup--content',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#batchTrackItem__modal .vs-popup .vs-popup--content > .con-vs-loading')
      }
    },

    'filters.batchId': {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.dataList = []
          this.page = 1
          this.getInitialRecords()
        }
      }
    },

    // handle callback for edit plant
    isEditPlantModalShow: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          setTimeout(() => {
            this.isEditPlantModalMounted = false
            this.selectedItem = null
          }, 0)
        }
      }
    },

    // handle callback for split package
    isSplitPackageModalShow: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          setTimeout(() => {
            this.isSplitPackageModalMounted = false
            this.selectedItem = null
          }, 0)
        }
      }
    },

    // handle callback for remove waste modal
    isRemoveWasteModalShow: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          setTimeout(() => {
            this.isRemoveWasteModalMounted = false
          }, 0)
        }
      }
    },

    // handle callback for create harvest modal
    isCreateHarvestPackageModalShow: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          setTimeout(() => {
            this.isCreateHarvestPackageModalMounted = false
          }, 0)
        }
      }
    },

    // handle callback for create harvest lab modal
    isCreateHarvestLabPackageModalShow: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          setTimeout(() => {
            this.isCreateHarvestLabPackageModalMounted = false
          }, 0)
        }
      }
    },

    // handle callback for update package qty
    isUpdatePackageQtyModalShow: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          setTimeout(() => {
            this.isUpdatePackageQtyModalMounted = false
            this.selectedItem = null
          }, 0)
        }
      }
    }
  },

  beforeRouteLeave(_, __, next) {
    // ...
    this.isActive = false
    this.isEditPlantModalShow = false
    this.isSplitPackageModalShow = false
    this.isRemoveWasteModalShow = false
    this.isCreateHarvestPackageModalShow = false
    this.isCreateHarvestLabPackageModalShow = false
    this.isUpdatePackageQtyModalShow = false
    this.isUpdateBatchStatusModalShow = false

    this.$nextTick(() => {
      next()
    })
  }
}
</script>

<style lang="scss">
#batchTrackItem__modal {
  .vs-popup {
    width: calc(100% - 30%) !important;
    position: relative;

    .con-vs-loading {
      position: absolute;
    }
  }
}

.con-vs-dropdown--menu {
  z-index: 99999 !important;
}

.batch_data__actions {
  width: 250px;
  z-index: 99999;

  li {
    padding: 5px;

    a {
      display: flex !important;
      font-weight: bold;
      align-items: center;
    }
  }
}
</style>
